import React from "react";

export default function MarketCards(){
  const cards = [
    {coin:"BTC/USDT", price:"96,588.90", icon:"🟠"},
    {coin:"ETH/USDT", price:"3,198.77", icon:"🔵"},
    {coin:"LTC/USDT", price:"96.44", icon:"⚪"},
  ];

  return (
    <div className="cards-row">
      {cards.map((c, i) => (
        <div key={i} className="card-market" style={{marginBottom:10}}>
          <div className="left">
            <div className="coin-bubble">{c.icon}</div>
            <div>
              <div className="ticker">{c.coin}</div>
              <div className="price">{c.price}</div>
            </div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontWeight:700,color:"var(--accent)"}}>Balance</div>
            <div style={{color:"var(--muted)",fontSize:13}}>View</div>
          </div>
        </div>
      ))}
    </div>
  );
}